import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';

export type StructuredDataProps = {
  name: string;
  image: string;
  sku: string | number;
  price: number;
  currency: string;
};

const StructuredData: React.FC<StructuredDataProps> = ({
  name,
  image,
  currency,
  price,
  sku
}) => {
  const router = useRouter();

  React.useEffect(() => {
    const resetDatalayer = () => {
      if (window && window.dataLayer) {
        window.dataLayer.push(function (this: DataLayer) {
          this.reset();
        });
      }
    };
    router.events.on('routeChangeComplete', resetDatalayer);

    return () => {
      router.events.off('routeChangeComplete', resetDatalayer);
    };
  });

  return (
    <Head>
      <script
        type='application/ld+json'
        key='product-jsonld'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            name,
            image,
            'offers': {
              price,
              'availability': 'http://schema.org/InStock',
              'url': `${process.env.NEXT_PUBLIC_CANONICAL_HOST}${router.asPath}`,
              '@type': 'Offer',
              'priceCurrency': currency
            },
            sku,
            '@context': 'http://schema.org',
            '@type': 'Product'
          })
        }}
      />
    </Head>
  );
};

export default React.memo(StructuredData);
